webpackJsonp([9],{

/***/ 747:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_vue__ = __webpack_require__(790);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a5af516_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_login_vue__ = __webpack_require__(838);
var normalizeComponent = __webpack_require__(105)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a5af516_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 766:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.5ea00f2.png";

/***/ }),

/***/ 790:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_const__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(108);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'login',
  data: function data() {
    return {
      formData: { email: '', password: '', type: 'sns' },
      LINK_BANNER: __WEBPACK_IMPORTED_MODULE_3__config_const__["a" /* LINK_BANNER */]
    };
  },

  computed: {
    canShowSurvey: function canShowSurvey() {
      return __WEBPACK_IMPORTED_MODULE_5__config__["c" /* CAN_SHOW_SURVEY */].indexOf(this.$auth.user().authority) !== -1;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])({
    getNotifications: 'masterData/getNotifications',
    setIsShowSurveyToLocalStorage: 'surveys/setIsShowSurveyToLocalStorage'
  }), {
    login: function login() {
      var _this = this;

      this.$validator.validateAll().then(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(res) {
          var loading;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (res) {
                    loading = _this.$loading.show({ opacity: 1 });

                    _this.$auth.login({
                      data: _this.formData,
                      fetchUser: false,
                      redirect: false,
                      rememberMe: true,
                      success: function () {
                        var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(response) {
                          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                            while (1) {
                              switch (_context.prev = _context.next) {
                                case 0:
                                  _context.next = 2;
                                  return _this.$auth.token(null, response.data.token);

                                case 2:
                                  _context.next = 4;
                                  return _this.$auth.fetch();

                                case 4:
                                  if (!(_this.$auth.user().is_maker && _this.canShowSurvey)) {
                                    _context.next = 7;
                                    break;
                                  }

                                  _context.next = 7;
                                  return _this.setIsShowSurveyToLocalStorage();

                                case 7:
                                  _this.$router.push('/');
                                  loading.hide();

                                case 9:
                                case 'end':
                                  return _context.stop();
                              }
                            }
                          }, _callee, _this);
                        }));

                        return function success(_x2) {
                          return _ref2.apply(this, arguments);
                        };
                      }(),
                      error: function error(e) {
                        loading.hide();
                        var code = e.response.status;
                        if (code === 403) {
                          _this.$message({ message: 'あなたのSNS権限では本機能を利用できません', type: 'error' });
                        } else if (code === 401) {
                          var message = '\u30D1\u30B9\u30EF\u30FC\u30C9\u306E\u6709\u52B9\u671F\u9650\u304C\u5207\u308C\u3066\u3044\u307E\u3059\u3002\u300C\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5FD8\u308C\u305F\u5834\u5408\u300D \u306E\u30EA\u30F3\u30AF\u304B\u3089\u3001\u30D1\u30B9\u30EF\u30FC\u30C9\u306E\u518D\u8A2D\u5B9A\u3092\u884C\u3063\u3066\u304F\u3060\u3055\u3044\u3002';
                          _this.$message({ message: message, type: 'success' });
                          _this.$router.push({ name: 'forgot-password' });
                        } else if (code === 402) {
                          _this.$message({ message: 'パスワードの有効期限が切れています。パスワードの再設定を行ってください。', type: 'error' });
                          _this.$router.push({ path: '/reset-password/' + e.response.data.token });
                        } else {
                          _this.$message({ message: '入力されたユーザーは存在しません!', type: 'error' });
                        }
                      }
                    });
                  }

                case 1:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, _this);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  })
});

/***/ }),

/***/ 838:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login_screen"},[_c('div',{staticClass:"login_image"},[_c('img',{attrs:{"src":__webpack_require__(839),"alt":""}}),_vm._v(" "),_c('a',{attrs:{"href":_vm.LINK_BANNER,"target":"_blank"}})]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"login_form"},[_c('div',{staticClass:"mb-1"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"},{name:"model",rawName:"v-model",value:(_vm.formData.email),expression:"formData.email"}],staticClass:"p-15",attrs:{"name":"form_email","type":"email","placeholder":"メールアドレス"},domProps:{"value":(_vm.formData.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "email", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"vee-validate-message"},[_vm._v(_vm._s(_vm.errors.first('form_email')))])]),_vm._v(" "),_c('div',{staticClass:"mb-1"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:6'),expression:"'required|min:6'"},{name:"model",rawName:"v-model",value:(_vm.formData.password),expression:"formData.password"}],staticClass:"p-15",attrs:{"name":"password","type":"password","placeholder":"パスワード"},domProps:{"value":(_vm.formData.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "password", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"vee-validate-message"},[_vm._v(_vm._s(_vm.errors.first('password')))])]),_vm._v(" "),_c('p',{staticClass:"forgot_password_link"},[_c('router-link',{attrs:{"to":{name: 'forgot-password'}}},[_vm._v("パスワードを忘れた場合")])],1),_vm._v(" "),_c('a',{staticClass:"button deep_blue block",attrs:{"href":"javascript:void(0)"},on:{"click":_vm.login}},[_vm._v("ログイン")])]),_vm._v(" "),_c('p',{staticClass:"term-of-use-link text-center"},[_c('router-link',{attrs:{"to":{name: 'term-of-use'}}},[_vm._v("利用契約")])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":__webpack_require__(766),"alt":""}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 839:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/login-image.dfda504.jpg";

/***/ })

});


// WEBPACK FOOTER //
// static/js/9.e124e957b300f8475f8c.js